<template>
  <div>
    <div class="top-hero2 flex justify-center">
      <div class="w-full sm:w-8/12 sm:mt-8 rounded-lg">
        <div class="content-center mt-12 sm:mt-0">
          <div class="w-full">
            <v-toolbar color="#01579B" class="top-hero6" dark flat>
              <v-toolbar-title class="text-lg">Reviews</v-toolbar-title>
            </v-toolbar>

            <div class="relative bg-gray-50 ">
              <div class="relative">
                <sales @clicked="showFooter = true"></sales>

                <client-reviews
                  :singleRev="singleRev"
                  :singleImage="singleImage"
                ></client-reviews>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="hidden sm:block" v-if="showFooter">
      <footer-links></footer-links>
    </div>  -->
    <div class="block sm:hidden my-16"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFooter: false,
      singleRev: this.$route.params.id,
      singleImage: this.$route.params.image
    };
  },

  methods: {}
};
</script>

<style scoped>
.bg-image {
  background-color: #fafafa;
  background-image: url("https://revistaaxxis.com.co/wp-content/uploads/2019/09/llano-axxis1.jpg");
}
</style>
